import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {IWindow} from "../../index";

const IWindow: IWindow = (window as IWindow);
import {Button, Col, Row} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";

export class ElectionPollingUnitFormData {
    @observable election_id = IWindow.initialState.route.params.id || null;
    @observable name = '';
    @observable code = '';
    @observable station_number = '';
    @observable registered_voters: number | null = null;
    @observable state_id: number | null = null;
    @observable is_active = true;
    @observable local_government_area_id: number | null = null;
    @observable ward_id: number | null = null;
    @observable is_excluded = false;
}

export class ElectionPollingUnitForm extends CrudForm {
    modelName = 'ElectionPollingUnit';

    renderFields() {
        return (
            <>
                {!this.id ?
                    <>
                        <Field
                            label="Code"
                            name="code"
                            component={Input}
                            required={true}
                            store={this.formStore}
                        />
                        <Field
                            label="Name"
                            name="name"
                            component={Input}
                            required={true}
                            store={this.formStore}
                        />

                        {/*<Field
                            label="Station Number"
                            name="station_number"
                            component={Input}
                            required={true}
                            store={this.formStore}
                        />*/}

                        <Field
                            label="State"
                            name="state_id"
                            component={Select}
                            required={true}
                            loadOptions={api.state.getListAction}
                            store={this.formStore}
                            onChange={() => {
                                this.formStore.setValue('local_government_area_id', null);
                                this.formStore.setValue('ward_id', null);
                            }}
                        />

                        <Field
                            key={this.formStore.getValue('state_id')}
                            label="Local Government Area"
                            name="local_government_area_id"
                            component={Select}
                            required={true}
                            valueObject={true}
                            loadOptions={() => {
                                return api.localGovernmentArea.getListAction({
                                    filters: {
                                        state_id: this.formStore.getValue('state_id')
                                    }
                                });
                            }}
                            store={this.formStore}
                            onChange={() => {
                                this.formStore.setValue('ward_id', null);
                            }}
                        />

                        <Field
                            key={"ward_id_" + this.formStore.getValue('state_id') +
                            this.formStore.getValue('local_government_area_id')}
                            label="Ward"
                            name="ward_id"
                            component={Select}
                            required={true}
                            valueObject={true}
                            loadOptions={() => {
                                return api.ward.getListAction({
                                    filters: {
                                        state_id: this.formStore.getValue('state_id'),
                                        local_government_area_id: this.formStore.getValue('local_government_area_id'),
                                    }
                                });
                            }}
                            store={this.formStore}
                        />
                    </>
                    : ''}

                    {this.id ?
                    <>
                        <p>Election: {this.entity.election.name}</p>
                        <p>Polling Unit: {this.entity.polling_unit.state.name} /
                            {this.entity.polling_unit.local_government_area.name} /
                            {this.entity.polling_unit.ward.name} /
                            {this.entity.polling_unit.name}
                        </p>

                    </> : ''

                }

                <Field
                    label="Registered Voters"
                    name="registered_voters"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    name="is_excluded"
                    component={BooleanRadios}
                    trueLabel="Excluded"
                    falseLabel="Included"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class ElectionPollingUnitFilterForm {
    @observable election_id = IWindow.initialState.route.params.id || null;
    @observable state_id = null;
    @observable local_government_area_id = null;
    @observable ward_id = null;
    @observable federal_constituency_id = null;
    @observable senatorial_district_id = null;
    @observable state_constituency_id = null;
    @observable election_position_id = null;
    @observable level = null;
}

export class ElectionPollingUnitList extends CrudList {
    modelName = 'ElectionPollingUnit';
    @observable election: any = null;
    @observable level: string = '';

    loadMoreData() {
        api.election.getDetailAction(this.filterFormStore.getValue('election_id')).then((data: any) => {
            this.election = data;
        })
    }

    senatorialDistrictDropDown() {
        return this.level === 'senatorial_district' ?
            <Col md={3} lg={4} xl>
                <Field
                    key={ 'filter-sd-drop-' + this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')}
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col>: ''
    }

    federalConstituencyDropDown() {
        return this.level === 'federal_constituency' ?
            <Col md={3} lg={4} xl>
                <Field
                    key={ 'filter-fc-drop-' + this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')}
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
                    }}
                />
            </Col>: ''
    }

    stateConstituencyDropDown() {
        return this.level === 'state_constituency' ?
            <Col md={3} lg={4} xl>
                <Field
                    key={ 'filter-sc-drop-' + this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')}
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.level
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                    }}
                />
            </Col>: ''
    }

    colums() {
        return [
            {
                name: "polling_unit.station_number",
                label: "Station Number",
                sort: true,
                sortColumn:'station_number',
            },
            {
                name: "polling_unit.state.code",
                label: "State Code",
                sort: true,
                sortColumn:'state.code',
            },
            {
                name: "polling_unit.state.name",
                label: "State",
                sort: true,
                sortColumn:'state.name',
            },
            {
                name: "polling_unit.local_government_area.code",
                label: "LGA Code",
                sort: true,
                sortColumn:'local_government_area.code',
            },
            {
                name: "polling_unit.local_government_area.name",
                label: "LGA",
                sort: true,
                sortColumn:'local_government_area.name',
            },
            {
                name: "polling_unit.ward.code",
                label: "Ward Code",
                sort: true,
                sortColumn:'ward.code',
            },
            {
                name: "polling_unit.ward.name",
                label: "Ward",
                sort: true,
                sortColumn:'ward.name',
            },
            {
                name: "code",
                label: "Polling Unit Code",
                sort: true,
                sortColumn:'code',
            },
            {
                name: "name",
                label: "Polling Unit Name",
                sort: true,
                sortColumn:'name',
            },
            {
                name: "registered_voters",
                label: "INEC Reg. Voters",
                sort: true,
                sortColumn:'registered_voters',
            },
            {
                name: "is_excluded",
                label: "Status",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {
                                value ?
                                    <Button color="polling-unit-status" onClick={() => this.updateStatus(item)}><span
                                        className="badge badge-danger">Excluded</span></Button>
                                    :
                                    <Button color="polling-unit-status" onClick={() => this.updateStatus(item)}><span
                                        className="badge badge-success">Included</span></Button>
                            }
                        </>
                    );
                },
            },
        ];
    }

    idColumn() {
        return '';
    }
    
    updateStatus(item: any) {
        if (confirm('Are you sure you want to update status?')) {
            api.electionPollingUnit.postUpdateStatusAction(item.id, {'is_excluded': !item.is_excluded}).then(() => {
                this.listTableStore.refresh();
            })
        }
    }

    renderFilters() {
        return (
            <>
                {
                    this.election ?
                        <>
                            <Row className="form-row">
                                <Col md={12} className="grid-search">
                                    <div className={'d-flex'}>
                                        <label className={'p-3 bg-light rounded mr-2'}>{this.election.election_type.name}</label>
                                        <label className={'p-3 bg-light rounded mr-2'}>{this.election.name}</label>
                                        <label className={'p-3 bg-light rounded mr-2'}>{this.election.election_at}</label>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="form-row">

                                <Col md={3}>
                                    <Field
                                        key={'filer-election-position' + this.election.id  }
                                        placeholder="Position"
                                        name="election_position_id"
                                        component={Select}
                                        required={true}
                                        loadOptions={() => {
                                            return api.electionPosition.getListAction({
                                                filters: {
                                                    election_id: this.election ? this.election.id : null,
                                                }
                                            });
                                        }}
                                        store={this.filterFormStore}
                                        returnObject={true}
                                        extraKey={'level'}
                                        onChange={(item: any) => {
                                            this.level = item.extraKey;
                                            this.filterFormStore.setValue('level', item.extraKey);
                                            this.filterFormStore.setValue('state_id', null);
                                            this.filterFormStore.setValue('senatorial_district_id', null);
                                            this.filterFormStore.setValue('federal_constituency_id', null);
                                            this.filterFormStore.setValue('local_government_area_id', null);
                                            this.filterFormStore.setValue('state_constituency_id', null);
                                            this.filterFormStore.setValue('ward_id', null);
                                        }}
                                    />
                                </Col>

                                { this.level !== 'polling_unit' &&
                                <Col md={3}>
                                    <Field
                                        key={'filer-state' + this.filterFormStore.getValue('election_position_id') + this.level}
                                        name="state_id"
                                        placeholder="Select State"
                                        component={Select}
                                        loadOptions={() => {
                                            return api.state.getListAction({
                                                filters: {
                                                    election_id: this.election ? this.election.id : null,
                                                    election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                    level: this.level
                                                }
                                            });
                                        }}
                                        store={this.filterFormStore}
                                        onChange={() => {
                                            this.filterFormStore.setValue('senatorial_district_id', null);
                                            this.filterFormStore.setValue('federal_constituency_id', null);
                                            this.filterFormStore.setValue('local_government_area_id', null);
                                            this.filterFormStore.setValue('state_constituency_id', null);
                                            this.filterFormStore.setValue('ward_id', null);
                                        }}
                                    />
                                </Col> }

                                {
                                    this.level && this.level !== 'polling_unit' ?
                                        <>
                                            {this.senatorialDistrictDropDown()}

                                            {this.federalConstituencyDropDown()}
                                        </> : ''
                                }
                                {
                                    this.level !== 'state_constituency'  && this.level !== 'polling_unit' ?
                                    <Col md={3}>
                                        <Field
                                            key={'filter-' + this.filterFormStore.getValue('state_id') +
                                            this.filterFormStore.getValue('election_position_id') +
                                            this.filterFormStore.getValue('senatorial_district_id') +
                                            this.filterFormStore.getValue('federal_constituency_id') +
                                             this.level }
                                            name="local_government_area_id"
                                            placeholder="Select LGA"
                                            component={Select}
                                            loadOptions={() => {
                                                return api.localGovernmentArea.getListAction({
                                                    filters: {
                                                        election_id: this.election ? this.election.id : null,
                                                        state_id: this.filterFormStore.getValue('state_id'),
                                                        senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                                                        federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                        level: this.level
                                                    }
                                                });
                                            }}
                                            store={this.filterFormStore}
                                            onChange={() => {
                                                this.filterFormStore.setValue('ward_id', null);
                                            }}
                                        />
                                    </Col> : ''
                                }

                                {
                                    this.level && this.level === 'state_constituency' ?
                                        <>
                                            {this.stateConstituencyDropDown()}
                                        </> : ''
                                }

                                <Col md={3}>
                                    <Field
                                        key={ "ward_id_" +
                                        this.filterFormStore.getValue('state_id') +
                                        this.filterFormStore.getValue('local_government_area_id') +
                                        this.filterFormStore.getValue('state_constituency_id') +
                                        this.filterFormStore.getValue('election_position_id') + this.level
                                        }
                                        name="ward_id"
                                        placeholder="Select Ward"
                                        component={Select}
                                        loadOptions={() => {
                                            return api.ward.getListAction({
                                                filters: {
                                                    state_id: this.filterFormStore.getValue('state_id'),
                                                    local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                                                    state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                                                    election_position_id: this.filterFormStore.getValue('election_position_id'),
                                                    level: this.level,
                                                    no_position: (this.level === 'polling_unit') ? 1 : null,
                                                }
                                            });
                                        }}
                                        store={this.filterFormStore}
                                    />
                                </Col>

                                <Col md={3} className="grid-search">
                                    {this.renderSearch()}
                                </Col>
                            </Row>
                        </> : ''}
            </>
        );
    }
}

export class ElectionPollingUnitPage extends CrudPage {
    modelName = 'ElectionPollingUnit';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPollingUnitPage.tsx